import cx from 'classnames';
import React from 'react';

export const ColorPreview = ({
  backgroundColor,
  size = 'medium',
  shape = 'circle',
}: {
  backgroundColor?: string;
  size?: 'small' | 'medium';
  shape?: 'circle' | 'rectangle';
}) => (
  <div
    className={cx({
      'rounded-full': shape === 'circle',
      'rounded-[8px]': shape === 'rectangle',
      'size-4': size === 'small' && shape === 'circle',
      'size-6': (size === 'medium' || !size) && shape === 'circle',
      'h-[32px] w-[25px]': shape === 'rectangle',
    })}
    style={{
      backgroundColor,
    }}
  />
);
